import React from 'react'
import clxs from 'clsx'
import { makeStyles } from '@material-ui/styles'
import { Box, Typography, TypographyVariant } from '@material-ui/core'
import { Divider } from '../Divider'
import { mutualTheme } from '~/utils/theme'

export type TitledComponentProps = {
  title: string,
  bold?: boolean,
  className?: string,
  topDivider?: boolean,
  bottomDivider?: boolean,
  variant?: TypographyVariant
}

const useStyles = makeStyles({
  container: {
    marginBottom: mutualTheme.spacing(4)
  },
  title: (props: TitledComponentProps) => ({
    fontWeight: props.bold ? 700 : 'normal'
  }),
  text: {
    fontSize: 20,
    fontWeight: 'normal',
    fontFamily: 'Airbnb'
  },
  topDividerClassName: {
    marginTop: mutualTheme.spacing(0)
  }
})

export const TitledComponent: React.FC<TitledComponentProps> = (props) => {
  const { title, className, children, variant, topDivider, bottomDivider } = props
  const classes = useStyles(props)
  const textStyle = variant ? { className: classes.title } : { className: clxs(classes.title, classes.text) }

  return (
    <Box className={clxs(classes.container, className)}>
      {topDivider && <Divider dividerClassName={classes.topDividerClassName} />}
      <Typography {...textStyle} variant={variant}>{title}</Typography>
      {children}
      {bottomDivider && <Divider />}
    </Box>
  )
}
